import { FC } from 'react';
import {
  CategoryLandingBanner,
  CategoryLandingBannerProps,
} from '@rich-products-corp/cc-custom-components/dist/components/PageSections/marketing/landing-sections/category-landing-banner';

interface PageFolder {
  dataSourceConfigurations: {
    preloadedValue: {
      imageBannerMobile?: string | null;
      imageBannerDesktop?: string | null;
    };
  }[];
}

export const CategoryLandingPageBanner: FC<CategoryLandingBannerProps & { pageFolder: PageFolder }> = ({
  data,
  pageFolder
}) => {
  const { title, description, background_desktop, background_mobile } = data ?? {};

  return (
    <div>
      <CategoryLandingBanner
        data={{
          title,
          description,
          background_desktop,
          background_mobile,
        }}
      />
    </div>
  );
};
